import React from 'react';
import './DrawerChevron.less';

import ChevronIcon from 'new-images/chevron.svg';

export const DrawerChevron = ({isUp}) => {
	return (
		<span
			className={`drawer-chevron ${isUp ? 'drawer-chevron--up' : ''}`}
			dangerouslySetInnerHTML={{__html: ChevronIcon}}
		></span>
	);
};
